const getCurrentRefreshToken = () => {
  let user = JSON.parse(localStorage.getItem("user"));
  return user?.token.refreshToken;
};

export default getCurrentRefreshToken;
